export default {
  "title": "朵朵",
  "main": "162",
  "daylist": "159",
  "monthlist": "160",
  "totallist": "161",
  "ridelist": "155",
  "userdatalist": "154",
  "paylist": "157",
  "bikelist": "156",
  "dashboardno": "dashboard-1606211515529-86127",
  "projectno": "proj-xtrace-7e654d5be9aeb17eb6abc78a83f22-cn-hangzhou",
  "customerCensusDay": "190",
  "customerCensusMonth": "195",
  "customerCensusTime": "191",
  "siteCensusDay": "192",
  "siteCensusMonth": "194",
  "siteCensusTime": "193",
  "noPassDetail": "189",
  "controlDataAnalyze" : "197"
}


// WEBPACK FOOTER //
// ./src/config/duoduo.js